import React from "react";
import { Link, Route, Switch } from "react-router-dom";
import ArtisanFollowerList from "./FollowerList";
// import ArtisanProductsForm from "./ArtisanProductsForm";
import Content from "../../../../_psb/layout/Content";
import SubHeader from "../../../../_psb/layout/sub-header/SubHeader";
import Search from "../../../../components/form/Search"
import { connect } from "react-redux"
import getLangData from "../../../../utils/getLangData";
// import {setSearchValueAction} from "../../../modules/artisanProducts/Actions"
// import {searchValueSelector} from "../../../modules/artisanProducts/Selectors"

const artisanFollowerList = (props) => {
  // const {searchValue , setSearchValue} = props
  const lang = getLangData().general_words
  return (
    <>
      <SubHeader
        title={lang.artisan_follower_list}
        Component={() => (
          <>
            <Switch>
              {/* <Route
                exact
                path='/'
                component={() => {
                  return (
                    <>
                      <span className='kt-subheader__separator kt-subheader__separator--v'></span>
                      <Search searchValue={searchValue} setSearchValue={setSearchValue} />
                    </>
                  );
                }}
              /> */}
            </Switch>
          </>
        )}
      >
        <Switch>
          {/* <Route
            exact
            path='/my-products'
            component={() => (
              <Link
                to='/artisan-products/create'
                className='btn btn-brand btn-bold'
              >
                Add New{" "}
              </Link>
            )}
          /> */}

          {/* <Route
            exact
            path={["/artisan-products/create", "/artisan-products/:id"]}
            component={() => {
              return (
                <Link
                  to='/my-products'
                  className='btn-label-brand btn btn-bold'
                >
                  Back To List{" "}
                </Link>
              );
            }}
          /> */}
        </Switch>
      </SubHeader>
      <Content>
        <Switch>
          <Route
            exact
            path='/my-artisan-followers'
            component={ArtisanFollowerList}
          />
          {/* <Route  
            exact
            path='/artisan-products/create'
            component={ArtisanProductsForm}
          />
          <Route
            exact
            path='/artisan-products/:id'
            component={ArtisanProductsForm}
          /> */}
        </Switch>
      </Content>
    </>
  );
};

const mapStateToProps = (state) => ({
  // searchValue : searchValueSelector(state)
})

const mapDispatchToProps = {
  // setSearchValue : setSearchValueAction
}

export default connect(mapStateToProps, mapDispatchToProps)(artisanFollowerList);